import { useState } from "react";
import { AlertTriangle, X } from "lucide-react";

// Üç aşamalı silme onayı: Sil butonu (1) → "Emin misiniz?" (2) → "Son onay" (3) → silme
export function ConfirmDelete({ title, message, step2Message, onConfirm, onCancel, testid = "confirm-delete" }) {
  const [step, setStep] = useState(1);
  const [busy, setBusy] = useState(false);

  const confirm = async () => {
    setBusy(true);
    try { await onConfirm(); } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/40 p-4" onClick={(e) => e.stopPropagation()} data-testid={`${testid}-modal`}>   {/* z-[70]: diğer modalların (z-50) üstünde kalır */}
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
        <div className="flex items-center gap-2 px-4 py-3 border-b border-red-200 bg-red-50 rounded-t-lg">
          <AlertTriangle className="w-4 h-4 text-red-600" />
          <span className="text-sm font-bold text-red-800">{title}</span>
          <span className="px-1.5 py-0.5 rounded bg-red-200 text-red-800 text-[10px] font-bold" data-testid={`${testid}-step-badge`}>Adım {step} / 2</span>
          <button onClick={onCancel} className="ml-auto text-slate-400 hover:text-slate-700" data-testid={`${testid}-close`}><X className="w-4 h-4" /></button>
        </div>
        <div className="px-4 py-4 text-xs text-slate-700 leading-relaxed" data-testid={`${testid}-message`}>
          {step === 1 ? message : (step2Message || "Bu işlemi gerçekleştirmek istediğinize tekrar emin misiniz?")}
        </div>
        <div className="flex justify-end gap-2 px-4 py-3 border-t border-slate-200">
          <button onClick={onCancel} data-testid={`${testid}-cancel`}
            className="px-3 py-2 rounded-md border border-slate-300 bg-white text-xs font-semibold text-slate-600 hover:bg-slate-50">
            Vazgeç
          </button>
          {step === 1 ? (
            <button onClick={() => setStep(2)} data-testid={`${testid}-step1-yes`}
              className="px-3 py-2 rounded-md bg-amber-600 text-white text-xs font-semibold hover:bg-amber-700">
              Evet, Devam Et
            </button>
          ) : (
            <button onClick={confirm} disabled={busy} data-testid={`${testid}-step2-yes`}
              className="px-3 py-2 rounded-md bg-red-700 text-white text-xs font-semibold hover:bg-red-800 disabled:opacity-50">
              {busy ? "Siliniyor…" : "Evet, Sil"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
